import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';

import { AuthenticationsService } from '../../modules/authentications/authentications.service';
import { AuthenticationLoginResponseDto } from '../../modules/authentications/dtos/authentication-login-response';
import { PermissionDeniedDialogComponent } from '../../modules/general/permission-denied/permission-denied-dialog.component';
import { AccessPermission } from '../../shared/enums/access-permission.enum';

export const permissionGuard: CanActivateFn = (
	route: ActivatedRouteSnapshot,
): boolean => {
	const authenticationsService = inject(AuthenticationsService);
	const dialog = inject(MatDialog);
	const organizationId = route.params.organization_id;

	const session: AuthenticationLoginResponseDto | null =
		authenticationsService.getSession();

	if (
		session?.organizationsWithViewPermission?.accessPermission ===
			AccessPermission.TOTAL ||
		session?.organizationsWithViewPermission?.organizationIds?.some(
			(id) => id === organizationId,
		)
	) {
		return true;
	}

	dialog.open(PermissionDeniedDialogComponent, {
		data: {
			message: 'Você não tem permissão para acessar os dados desta organização',
		},
	});

	return false;
};
